module.exports = __webpack_public_path__ + "img/exit-icon.fef7ebb9.svg";